(function () {
  'use strict';

  var cache = new Map();
  var optionSequence = 0;

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function suggestUrl(query) {
    return '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
  }

  function fetchSuggestions(query, signal) {
    if (cache.has(query)) return Promise.resolve(cache.get(query));
    return fetch(suggestUrl(query), { signal: signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search suggestions unavailable');
        return response.json();
      })
      .then(function (data) {
        var results = data && data.resources && data.resources.results ? data.resources.results : {};
        cache.set(query, results);
        return results;
      });
  }

  function optionLink(className, href) {
    var link = document.createElement('a');
    link.className = 'orbly-search__option ' + className;
    link.href = href;
    link.id = 'OrblySearchOpt' + optionSequence++;
    link.setAttribute('role', 'option');
    link.setAttribute('aria-selected', 'false');
    return link;
  }

  function imageUrl(source) {
    if (!source) return '';
    try {
      var url = new URL(typeof source === 'string' ? source : source.url, window.location.origin);
      url.searchParams.set('width', '120');
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function addProduct(container, product) {
    var link = optionLink('orbly-search__product', product.url);
    var thumb = document.createElement('span');
    thumb.className = 'orbly-search__thumb';
    var src = imageUrl(product.image);
    if (src) {
      var image = document.createElement('img');
      image.src = src;
      image.alt = '';
      image.width = 56;
      image.height = 56;
      image.loading = 'lazy';
      thumb.appendChild(image);
    }
    var title = document.createElement('span');
    title.className = 'orbly-search__title';
    title.textContent = product.title;
    var price = document.createElement('span');
    price.className = 'orbly-search__price';
    price.textContent = '$' + product.price;
    link.appendChild(thumb);
    link.appendChild(title);
    link.appendChild(price);
    container.appendChild(link);
  }

  function addViewAll(container, query) {
    var link = optionLink('orbly-search__view-all', '/search?q=' + encodeURIComponent(query));
    link.textContent = 'View all results →';
    container.appendChild(link);
  }

  function emptyState(container) {
    container.innerHTML = '';
    var label = document.createElement('p');
    label.className = 'orbly-search__label';
    label.textContent = 'Popular';
    var chips = document.createElement('div');
    chips.className = 'orbly-search__chips';
    [['Dogs', '/collections/dog'], ['Cats', '/collections/cat'], ['Grooming', '/collections/grooming']].forEach(function (item) {
      var chip = document.createElement('a');
      chip.className = 'orbly-chip';
      chip.href = item[1];
      chip.textContent = item[0];
      chips.appendChild(chip);
    });
    container.appendChild(label);
    container.appendChild(chips);
  }

  function closeOtherLayers() {
    var mobileNav = document.getElementById('mobile-nav');
    var mobileBackdrop = document.getElementById('mobile-nav-backdrop');
    var menuToggle = document.querySelector('.menu-toggle');
    if (mobileNav) {
      mobileNav.classList.remove('active');
      mobileNav.setAttribute('aria-hidden', 'true');
    }
    if (mobileBackdrop) mobileBackdrop.classList.remove('active');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');

    var drawerRoot = document.querySelector('cart-drawer') || document.querySelector('.drawer');
    var drawerOverlay = document.getElementById('CartDrawer-Overlay') || document.querySelector('.cart-drawer__overlay');
    var drawerPanel = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
    if (drawerRoot) drawerRoot.classList.remove('animate', 'active');
    if (drawerOverlay) drawerOverlay.classList.remove('active');
    if (drawerPanel) drawerPanel.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function initOverlay() {
    var sheet = document.querySelector('[data-orbly-search]');
    var backdrop = document.querySelector('[data-orbly-search-backdrop]');
    var input = sheet && sheet.querySelector('[data-orbly-search-input]');
    var results = sheet && sheet.querySelector('[data-orbly-search-results]');
    var status = sheet && sheet.querySelector('[data-orbly-search-status]');
    var closeButton = sheet && sheet.querySelector('[data-orbly-search-close]');
    var triggers = document.querySelectorAll('[data-orbly-search-open]');
    if (!sheet || !backdrop || !input || !results || !status || !closeButton || !triggers.length) return;

    var activeIndex = -1;
    var controller = null;
    var returnTrigger = triggers[0];
    var closeTimer = null;

    function options() {
      return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function setActive(index) {
      var items = options();
      if (!items.length) return;
      activeIndex = (index + items.length) % items.length;
      items.forEach(function (item, i) { item.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', items[activeIndex].id);
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function clearActive() {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function showEmpty() {
      if (controller) controller.abort();
      emptyState(results);
      clearActive();
      input.setAttribute('aria-expanded', 'false');
      status.textContent = '';
    }

    function render(query, data) {
      results.innerHTML = '';
      clearActive();
      var queries = (data.queries || []).slice(0, 3);
      var products = (data.products || []).slice(0, 6);
      products.forEach(function (product) { addProduct(results, product); });
      if (queries.length) {
        var label = document.createElement('p');
        label.className = 'orbly-search__label';
        label.textContent = 'Related searches';
        results.appendChild(label);
        queries.forEach(function (queryItem) {
          var link = optionLink('orbly-search__query', queryItem.url);
          var text = document.createElement('span');
          text.className = 'orbly-search__query-text';
          text.innerHTML = queryItem.styled_text;
          link.appendChild(text);
          results.appendChild(link);
        });
      }
      addViewAll(results, query);
      var count = queries.length + products.length;
      input.setAttribute('aria-expanded', 'true');
      status.textContent = count ? count + ' suggestions' : 'No suggestions — press Enter to search';
    }

    var update = debounce(function () {
      var query = input.value.trim();
      if (!query) { showEmpty(); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      fetchSuggestions(query, controller.signal)
        .then(function (data) { if (input.value.trim() === query) render(query, data); })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          results.innerHTML = '';
          clearActive();
          input.setAttribute('aria-expanded', 'false');
          status.textContent = '';
        });
    }, 250);

    function open(trigger) {
      clearTimeout(closeTimer);
      closeOtherLayers();
      returnTrigger = trigger || triggers[0];
      var header = document.querySelector('.site-header');
      if (header) {
        header.style.transform = 'translateY(0)';
        header.classList.add('site-header--scrolled');
      }
      backdrop.hidden = false;
      sheet.hidden = false;
      document.body.classList.add('orbly-search-open');
      document.body.style.overflow = 'hidden';
      if (!input.value.trim()) showEmpty();
      requestAnimationFrame(function () {
        backdrop.classList.add('is-open');
        sheet.classList.add('is-open');
        input.focus();
      });
    }

    function close() {
      if (sheet.hidden) return;
      if (controller) controller.abort();
      backdrop.classList.remove('is-open');
      sheet.classList.remove('is-open');
      document.body.classList.remove('orbly-search-open');
      document.body.style.overflow = '';
      closeTimer = setTimeout(function () {
        backdrop.hidden = true;
        sheet.hidden = true;
        if (returnTrigger && returnTrigger.focus) returnTrigger.focus();
      }, 200);
    }

    triggers.forEach(function (trigger) { trigger.addEventListener('click', function () { open(trigger); }); });
    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    input.addEventListener('input', update);

    document.addEventListener('keydown', function (event) {
      var target = event.target;
      var isEditing = target && (target.matches('input, textarea, select') || target.isContentEditable);
      if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey && !isEditing && sheet.hidden) {
        event.preventDefault();
        open(triggers[0]);
        return;
      }
      if (sheet.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowDown' && document.activeElement === input) {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp' && document.activeElement === input) {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === 'Enter' && document.activeElement === input && activeIndex >= 0) {
        var selected = options()[activeIndex];
        if (selected) {
          event.preventDefault();
          window.location.href = selected.href;
        }
      } else if (event.key === 'Tab') {
        var focusables = [input].concat(options()).concat([closeButton]);
        var current = focusables.indexOf(document.activeElement);
        if (event.shiftKey && current <= 0) {
          event.preventDefault();
          focusables[focusables.length - 1].focus();
        } else if (!event.shiftKey && current === focusables.length - 1) {
          event.preventDefault();
          focusables[0].focus();
        }
      }
    });
  }

  function initInline(form) {
    var input = form.querySelector('[data-orbly-search-inline-input]');
    var results = form.querySelector('[data-orbly-search-inline-results]');
    if (!input || !results) return;
    var controller = null;
    var update = debounce(function () {
      var query = input.value.trim();
      if (!query) {
        if (controller) controller.abort();
        results.innerHTML = '';
        results.hidden = true;
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      fetchSuggestions(query, controller.signal)
        .then(function (data) {
          if (input.value.trim() !== query) return;
          results.innerHTML = '';
          (data.products || []).slice(0, 5).forEach(function (product) { addProduct(results, product); });
          addViewAll(results, query);
          results.hidden = false;
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            results.innerHTML = '';
            results.hidden = true;
          }
        });
    }, 250);
    input.addEventListener('input', update);
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) results.hidden = true;
    });
  }

  initOverlay();
  document.querySelectorAll('[data-orbly-search-inline]').forEach(initInline);
})();
